import { useCallback, useEffect, useState } from "react";
import { Player, PlayersServices } from "@/services/bedrock";
import { usePaginatedCombobox } from "@/utils";

type PreviewDevice = "web" | "mobile";

const MOBILE_PREVIEW_WIDTH = 390;

const usePreviewPlayer = () => {
  const [previewPlayer, setPreviewPlayer] = useState<Player | null>(null);
  const [previewDevice, setPreviewDevice] = useState<PreviewDevice>("web");

  const getPlayers = useCallback(async (search: string | undefined, page: number) => {
    return PlayersServices.getPlayers({
      search,
      page,
      perPage: 25,
      sort: "first_name",
      sortDirection: "asc",
    });
  }, []);

  const players = usePaginatedCombobox(getPlayers, false, previewPlayer);
  useEffect(() => {
    setPreviewPlayer(players.value ?? null);
  }, [players.value]);

  return { players, previewPlayer, previewDevice, setPreviewDevice };
};

type PreviewPlayerState = ReturnType<typeof usePreviewPlayer>;

export { usePreviewPlayer, MOBILE_PREVIEW_WIDTH };
export type { PreviewDevice, PreviewPlayerState };
